import React from 'react';
import PropTypes from 'prop-types';
import { Tree, ExpandFormRow } from '@here/ref-client-ui';
import './gpxTraceResult.scss';

function GpxTraceResult({ result = {} }) {

  const { state: { gpxTrace = {}, selectedTracePoint } = {} } = result;

  return (
    <div className="rf-gpx-trace-result">
      <ExpandFormRow key={1} label={`Features`} isExpanded>
        <Tree data={gpxTrace} />
      </ExpandFormRow>
      {selectedTracePoint !== undefined && (
        <ExpandFormRow key={2} label={`Point ${selectedTracePoint}`} isExpanded>
          <Tree data={gpxTrace.features[selectedTracePoint]} />
        </ExpandFormRow>
      )}
    </div>
  );
}

GpxTraceResult.propTypes = {
  result: PropTypes.object,
};

export default GpxTraceResult;
